hmi.utils.insert_module({
    name: 'text',
    instance: null,
    groupType: hmi.constant.groupType.component,
    type: hmi.constant.TEXT,
    pipe: false,
    svgName: 'samplerLabel',
});

hmi.models.text = function () {
    "use strict";

    //============================================================
    // Public Variables with Default Settings
    //------------------------------------------------------------
    var showMode = hmi.constant.showMode.monitor,
        availableWidth,
        availableHeight,
        valueFormat = d3.format(',.3f');


    //============================================================
    // Private Variables
    //------------------------------------------------------------


    var allData = [],
        type = hmi.constant.TEXT,
        signal = hmi.constant.signals.digitalOrAnalog,
        groupType = hmi.constant.groupType.component,
        subComponent = {
            main: 0
        },
        selectTargetId,
        dragTarget,
        dispatch = d3.dispatch('componentChange', 'selectElement', 'selectText'),
        defaultWidth = 10,
        defaultHeight = 10;

    var addSubComponents = function (d, data) {
        d.components.push(addMainComponent(d, data));
    };

    var addMainComponent = function (d, data) {
        var result = null;
        if (!data) {
            result = {
                id: d.id + '-sub-' + (subComponent.main + 1),
                key: d.id + '-sub-' + (subComponent.main + 1),
                index: subComponent.main,
                width: defaultWidth,
                height: defaultHeight,
                x: 0,
                y: 0,
                text: d.text,
                font: 'bold 15px sans-serif',
            };
        } else {
            result = {
                id: data.components[subComponent.main].id,
                key: data.components[subComponent.main].key,
                index: data.components[subComponent.main].index,
                width: data.components[subComponent.main].width,
                height: data.components[subComponent.main].height,
                x: data.components[subComponent.main].x,
                y: data.components[subComponent.main].y,
                text: data.text,
                font: data.components[subComponent.main].font,
            };
        }

        return result;
    };

    var selectComponent = function () {
        d3.select(dragTarget)
            .style('stroke', hmi.utils.color.select);
    };

    var unSelectComponent = function () {
        d3.select(dragTarget).attr("pointer-events", "all")
            .style('stroke', null);
        dragTarget = null;
        selectTargetId = null;
    };

    var updateComponentPosition = function (d) {
        d.components[subComponent.main].x = d.x;
        d.components[subComponent.main].y = d.y;
        allData[d.index] = d;
    };

    var transformComponentPosition = function (componentTarget, component) {
        component.select = false;
    };

    var initializeCanvasObjects = function (gComponent, gEnter) {

        //add main component
        var textAlias = gComponent
            .append('text')
            .classed('component-ele', true)
            .attr('parent', function (d) {
                return d.id;
            })
            .attr('id', function (d) {
                return d.components[subComponent.main].id;
            })
            ;

        gEnter.select('text.component-ele')
            // .attr('x', function (d) {
            //     return d.components[subComponent.main].x;
            // })
            // .attr('y', function (d) {
            //     return d.components[subComponent.main].y;
            // })
            .style('font', function (d) {
                return hmi.utils.generateFont(d.config.valueFont);
            })
            .style('fill', function (d) {
                if (d.data.alarmColor) {
                    return d.data.alarmColor;
                }
                return d.components[subComponent.main].fill;
            })
            .text(function (d) {
                var unitMeasure = '';
                if (d.config && d.config.unitMeasure) {
                    unitMeasure = d.config.unitMeasure;
                }
                var value = hmi.utils.generateValueFormat(d.data.value, d.config.valueFont.valueFormat, unitMeasure);
                var textValue = '';
                if (d.alias) {
                    textValue = d.alias;
                } else {
                    textValue = d.components[subComponent.main].text;
                }
                return textValue + ': ' + value;
            });


        textAlias.on('click', function (event) {
            d3.event.stopPropagation();
            hmi.utils.unSelectComponent();
            event.select = true;
            selectTargetId = d3.select(this).attr('parent');
            switch (showMode) {
                // click in design mode
                case hmi.constant.showMode.design:
                    dragTarget = this;

                    selectComponent();
                    dispatch.selectElement({
                        component: selectTargetId,
                        signal: signal
                    });
                    dispatch.selectText({
                        'key': event.key,
                        'sub_key': selectTargetId,
                        'valueFont': event.config.valueFont
                    });
                    break;
                case hmi.constant.showMode.match:
                    dispatch.selectElement({
                        component: selectTargetId,
                        signal: signal
                    });
                    dragTarget = this;
                    selectComponent();
                    break;
            }
        });
    };

    function text(selection) {
        selection.each(function (data) {
            allData = data;
            var container = d3.select(this).data(data);

            text.container = this;

            container.selectAll('g.nv-group-text')
                .data([data])
                .enter()
                .append('g')
                .attr('class', 'nv-group-text');

            var gEnter = d3.select('g.nv-group-text')
                .selectAll('g.nv-text')
                .data(data, function (item) {
                    return item.key;
                });

            var gComponent = gEnter.enter()
                .append('g')
                .attr('class', 'nv-text')
                .attr('id', function (d) {
                    if (d.components[subComponent.main].x === 0) {
                        updateComponentPosition(d);
                    }
                    return d.id;
                })
                .call(hmi.dragBehavior.dragComponent);

            gEnter
                .attr('x', function (d) {
                    return d.x;
                })
                .attr('y', function (d) {
                    return d.y;
                })
                .attr('transform', function (d) {
                    return 'translate(' + d.components[subComponent.main].x + ',' +
                        d.components[subComponent.main].y + ')';
                });

            initializeCanvasObjects(gComponent, gEnter);
            gEnter.exit().remove();
            text.update = function () {
                container.datum(allData).call(text);
            };

        });

        return text;
    }

    text.dispatch = dispatch;

    text.options = hmi.utils.optionsFunc.bind(text);

    text._calls = new function () {
        this.getObject = function (data) {
            var result = null;
            if (!data) {
                result = {
                    id: 'sampler-label-' + (allData.length + 1),
                    key: 'sampler-label-' + (allData.length + 1),
                    index: allData.length,
                    groupType: groupType,
                    type: type,
                    width: defaultWidth,
                    height: defaultHeight,
                    x: 0,
                    y: 0,
                    text: 'sampler-label-' + (allData.length + 1),
                    config: {
                        aliasFont: {
                            weight: 'bold',
                            size: '15px',
                            family: 'sans-serif'
                        },
                        valueFont: {
                            weight: 'bold',
                            size: '15px',
                            family: 'sans-serif',
                            valueFormat: '+,.3f'
                        }
                    },
                    components: [],
                    data: {
                        value: 0
                    }
                };
                addSubComponents(result, null);
            } else {
                result = {
                    id: data.id,
                    key: data.key,
                    index: data.index,
                    groupType: groupType,
                    type: data.type,
                    width: data.width,
                    height: data.height,
                    x: data.x,
                    y: data.y,
                    text: data.text,
                    config: data.config,
                    components: [],
                    data: {
                        value: 0
                    }
                };
                addSubComponents(result, data);
            }
            this.updateConfig = function (data) {
                var item = allData.find(function (item) {
                    return item.key === data.key;
                });
                if (item) {
                    item.alias = data.alias;
                    item.config.unitMeasure = data.config.unitMeasure ? data.config.unitMeasure : item.config.unitMeasure;
                    item.config.aliasFont = data.config.aliasFont ? data.config.aliasFont : item.config.aliasFont;
                    item.config.valueFont = data.config.valueFont ? data.config.valueFont : item.config.valueFont;
                }
                return item;
            };
            this.unSelectComponent = unSelectComponent;
            this.updateComponentPosition = updateComponentPosition;
            this.transformComponentPosition = transformComponentPosition;

            return result;
        };
    };

    text._options = Object.create({}, {
        // simple options, just get/set the necessary values
        showMode: {
            get: function () {
                return showMode;
            },
            set: function (_) {
                showMode = _;
            }
        },
        availableWidth: {
            get: function () {
                return availableWidth;
            },
            set: function (_) {
                availableWidth = _;
            }
        },
        availableHeight: {
            get: function () {
                return availableHeight;
            },
            set: function (_) {
                availableHeight = _;
            }
        },
        valueFormat: {
            get: function () {
                return valueFormat;
            },
            set: function (_) {
                valueFormat = _;
            }
        }
    });

    hmi.utils.initOptions(text);

    return text;
};